const CLOSED_CHECKOUT_REVIEW_STATUSES: ReadonlySet<string> = new Set([
  "fulfilled",
  "refunded",
]);

export function hasOpenCheckoutReview(order: {
  payment?: { checkoutReview?: { status: string } };
}): boolean {
  const status = order.payment?.checkoutReview?.status;
  return status !== undefined && !CLOSED_CHECKOUT_REVIEW_STATUSES.has(status);
}

export function awaitsAccountingDecision(order: {
  paymentStatus?: string;
  accountingReview?: { status: string };
  payment?: { checkoutReview?: { status: string } };
}): boolean {
  return (
    order.accountingReview?.status === "pending" ||
    order.paymentStatus === "pending_review" ||
    hasOpenCheckoutReview(order)
  );
}
